<template>
  <div class="upload">
    <h1>Upload Show</h1>

    <div class="container">

      <div class="choosing-files" v-if="!isUploading">
        <div class="upload">
          <label>Files
            <input type="file" id="file" ref="files" v-on:change="handleFileUpload()" multiple />
          </label>
        </div>

        <div class="utilities">
          <div class="global-showname">
            <input type="text" @input="setGlobalShowName" v-model="globalShowName" placeholder="showname" :disabled="isUploading">

            <select name="shows" @change="selectShow" :disabled="isUploading">
              <option selected value=""></option>
              <option v-for="show in shows" :key="show.name" :value="show.name">{{show.name}}</option>
            </select>
          </div>

          <div class="global-showname">
            <input type="text" @input="setGlobalSeasonName" v-model="globalSeasonName" placeholder="seasonname" :disabled="isUploading">

            <select name="seasons" @change="selectSeason" v-if="seasons.length > 0" :disabled="isUploading">
              <option selected value=""></option>
              <option v-for="season in seasons" :key="season.name" :value="season.name">{{season.name}}</option>
            </select>
          </div>

          <div class="start-episode">
            <input type="number" @input="setEpisodeStartNumber" v-model="episodeStartNumber" placeholder="episodestart" :disabled="isUploading">
          </div>
        </div>

        <div class="list">

          <div v-for="(file, key) in files" :key="key" class="file-item">

            <div class="file">{{file.file.name}}</div>

            <div class="name">
              <input type="text" v-model="file.name" placeholder="name" :disabled="isUploading">
            </div>

            <div class="show-name">
              <input type="text" v-model="file.showName" placeholder="showname" :disabled="isUploading">
            </div>

            <div class="season-name">
              <input type="text" v-model="file.seasonName" placeholder="seasonname" :disabled="isUploading">
            </div>

          </div>

        </div>

        <div class="submit">
          <button @click="submit()">Upload</button>
        </div>
      </div>

      <div class="uploading" v-else>
        <div class="uploadbar" style="position: relative">
          <div class="current" :style="'width: ' + (currentUpload / files.length * 100) + '%; height: 100%; background-color: green'">
            <span class="label">Uploading videos ({{currentUpload}}/{{files.length}}) </span>
          </div>
        </div>

        <div v-if="currentUpload >= files.length">
          <div>Succesfully uploaded videos</div>
          <button @click="$router.push('/shows')">Shows</button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

import config from '../config'

const ALLOWED_EXTENSIONS = ['mp4', 'mkv', 'm4v']

export default {
  name: 'Upload',
  data () {
    return {
      files: [],
      shows: [],
      seasons: [],
      globalShowName: '',
      globalSeasonName: '',
      isUploading: false,
      currentUpload: 0,
      episodeStartNumber: 1
    }
  },
  methods: {
    setEpisodeStartNumber(e) {
      this.episodeStartNumber = e.target.value;

      this.files.forEach((file, key) => {
        file.name = `Episode ${(key + parseInt(this.episodeStartNumber))}`
      })
    },
    selectShow(e) {
      this.globalShowName = e.target.value;

      this.files.forEach(file => {
        file.showName = e.target.value;
      })

      this.getSeasons(e.target.value)
    },
    selectSeason(e) {
      this.globalSeasonName = e.target.value;

      this.files.forEach(file => {
        file.seasonName = e.target.value;
      })
    },
    setGlobalShowName(e) {
      this.files.forEach(file => {
        file.showName = e.target.value;
      })
    },
    setGlobalSeasonName(e) {
      this.files.forEach(file => {
        file.seasonName = e.target.value;
      })
    },
    async submit() {

      this.isUploading = true;
      this.currentUpload = 0;

      for (let i = 0; i < this.files.length; i++) {
        const { file, name, showName, seasonName } = this.files[i];

        await this.upload(file, name, showName, seasonName)
          .then(() => {
            this.currentUpload += 1;

            console.log(`${file.name} has been uploaded`);
          })
          .catch(() => {
            this.files.push({
              file,
              name,
              showName,
              seasonName
            })
          })
      }
    },
    async upload(file, name, showName, seasonName){
        const token = localStorage.getItem('token');

        const formData = new FormData();
        formData.append('file', file);

        const result = await this.axios.post(config.api + '/upload',
          formData,
          {
            headers: {
                'Content-Type': 'multipart/form-data',
                'authorization': token
            }
          }
        )

        if (!result.data.status) {
          alert(`could not upload ${file.name}`);
          return;
        }

        const id = result.data.result.id;

        await this.axios.post(config.api + '/episode', {
            id,
            name,
            showName,
            seasonName
          }, {
            headers: {
              'authorization': token
            }
        })
    },
    getExtension(url) {
      const partials = url.split('.');

      return partials[partials.length - 1]
    },
    handleFileUpload(){

      this.files = Array.from(this.$refs.files.files).filter(file => {
        const fileExtension = this.getExtension(file.name);

        return ALLOWED_EXTENSIONS.includes(fileExtension);
      }).map((file, key) => {
        return {
          file,
          name: `Episode ${(key + parseInt(this.episodeStartNumber))}`,
          showName: this.globalShowName,
          seasonName: this.globalSeasonName
        }
      });
    },
    getShows() {
      const token = localStorage.getItem('token');

      this.axios.get(config.api + '/shows', {
        headers: {
          'authorization': token
        }
      })
        .then(result => {
          this.shows = result.data;
        })
    },
    getSeasons(show) {
      const token = localStorage.getItem('token');

      this.axios.get(config.api + '/seasons/' + show, {
        headers: {
          'authorization': token
        }
      })
      .then(result => {
        this.seasons = result.data;
      })
    }
  },
  created() {
    this.getShows();
  }
}
</script>

<style scoped>

.file-item {
  margin: 10px 0;
  padding: 20px;
  background-color: rgb(51, 51, 51);
  color: white;
}

.utilities, .submit, .uploading {
  margin: 50px 0;
  padding: 20px;
}

.uploadbar {
  width: 100%;
  height: 25px;
  border: 3px solid black;
  border-radius: 5px;
}

.label {
  color: white;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/components/UploadShow.vue